import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { EventData } from "../../models/EventData";
import { BsData } from "../../models/BsData";
import { UserBet } from "../../models/UserBet";
import PremiumMarkets from "../../components/PremiumMarkets/PremiumMarkets";
import {
  unsubscribeAllWsforEvents,
  subscribeWsForEventOdds,
  isDreamWsConnected,
} from "../../websockets/websocket";
import { fetchOpenBets, removeExchangeBet } from "../../store";
import "./AllMarketsPage.scss";
import moment from "moment";
import { TopicUrls } from "../../models/sportsBookState"

type StoreProps = {
  eventInfo: EventData;
  premiumEventInfo: EventData;
  fetchOpenBets: (eventId, sportId) => void;
  bets: BsData[];
  openBetsData: UserBet[];
  removeExchangeBet: (index: number) => void;
  isSocketConnected: boolean;
  topicUrls: TopicUrls;
};

export const MarketPremium: React.FC<StoreProps> = (props) => {
  const { eventInfo, bets, openBetsData, fetchOpenBets, premiumEventInfo, isSocketConnected, topicUrls } =
    props;
  const [openBetSlip, setOpenBetSlip] = useState<boolean>(false);

  useEffect(() => {
    if (!openBetSlip && bets.length > 0) {
      setOpenBetSlip(true);
    }
  }, [bets]);

  useEffect(() => {
    if (premiumEventInfo && premiumEventInfo?.eventId && topicUrls?.prTopic) {
      subscribeWsForEventOdds(
        topicUrls?.prTopic,
        sessionStorage.getItem("psProviderId"),
        premiumEventInfo?.eventId
      );
    }

    return () => {
      unsubscribeAllWsforEvents();
    };
  }, [premiumEventInfo?.eventId, isSocketConnected, topicUrls?.prTopic]);

  return (
    <div className="premium-market-ctn">
      <div className="">
        <PremiumMarkets tabValue={"all"} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
    bets: state.betslip.bets,
    eventInfo: state.sportsBook.eventInfo,
    topicUrls: state.sportsBook.topicUrls,
    openBetsData: state.betslip.openBets,
    premiumEventInfo: state.sportsBook.premiumEventInfo,
    isSocketConnected: state.sportsBook.isSocketConnected
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketPremium);
